import { SxProps, Theme } from "@mui/material";

export {
  LESSON_INTERACTIVE_COLORS as INTERACTIVE_COLORS,
  createInteractiveStyles,
  getInteractiveColorPalette,
  useInteractivePalette,
  useInteractiveStyles,
} from "./interactive-style-kit";
export type {
  InteractiveColorPalette,
  InteractiveStyleKit,
} from "./interactive-style-kit";

export const interactiveRootSx: SxProps<Theme> = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: 2,
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  py: 0.5,
  "@media (max-height: 600px)": {
    gap: 1,
    py: 0,
  },
};

export const assessmentInteractiveRootSx: SxProps<Theme> = interactiveRootSx;

export const getSubmittedItemHighlight = (
  isSubmitted: boolean,
  isCorrect?: boolean,
): "correct" | "incorrect" | undefined => {
  if (!isSubmitted || typeof isCorrect !== "boolean") return undefined;
  return isCorrect ? "correct" : "incorrect";
};

export const optionsPoolSx: SxProps<Theme> = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1,
};

export const matchingContainerSx: SxProps<Theme> = {
  position: "relative",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  display: "grid",
  gridTemplateColumns: {
    xs: "minmax(0, 1fr) 16px minmax(0, 1fr)",
    sm: "minmax(0, 1fr) 28px minmax(0, 1fr)",
    md: "minmax(0, 1fr) 48px minmax(0, 1fr)",
  },
  gap: { xs: 0.25, sm: 0.5, md: 1 },
  alignItems: "start",
};

export const matchingColumnSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 1,
  zIndex: 1,
  minWidth: 0,
  maxWidth: "100%",
  overflow: "hidden",
};

export const matchingItemTextSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  wordBreak: "break-word",
  overflowWrap: "anywhere",
  lineHeight: 1.35,
};
